module.exports = __webpack_public_path__ + "static/media/02_web_website-bs.681b8e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_website-bs.png
// module id = 329
// module chunks = 0